'use client'

import Image from 'next/image'

import { Icon, IconComponent } from '@graftcode/design-system'

import { NOTIFICATION_BADGE_VARIANT } from '../../const/notification-badge-variant.const'
import { getNotificationIconConfig } from '../../mappers/getNotificationIconConfig'
import type { NotificationType } from '../../types/notification-type.type'

import styles from './NotificationCardIcon.module.scss'

type Props = {
  type: NotificationType
}

export function NotificationCardIcon({ type }: Props) {
  const { icon, customIcon, badge } = getNotificationIconConfig(type)

  const badgeClassName = [
    styles.badge,
    badge === NOTIFICATION_BADGE_VARIANT.INFO && styles.badgeInfo,
    badge === NOTIFICATION_BADGE_VARIANT.WARNING && styles.badgeWarning,
    badge === NOTIFICATION_BADGE_VARIANT.ERROR && styles.badgeError,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={styles.iconWrap}>
      {customIcon ? (
        <Image src={customIcon} alt="" width={24} height={24} className={styles.customIcon} />
      ) : icon ? (
        <IconComponent icon={icon} size={24} className={styles.icon} />
      ) : null}
      {badge ? (
        <span className={badgeClassName}>
          {badge === NOTIFICATION_BADGE_VARIANT.INFO ? (
            <IconComponent icon={Icon.StarFilled} size={8} className={styles.badgeStar} />
          ) : (
            <IconComponent icon={Icon.ImportantFilled} size={8} className={styles.badgeIcon} />
          )}
        </span>
      ) : null}
    </div>
  )
}
